import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import {
  ComponentRow,
  OverTimeBucket,
  OverTimePeriod,
  SummaryResponse,
  SystemStat,
  TdpStatisticApi,
  TemplateStat,
} from './TdpStatisticApi';

export class TdpStatisticClient implements TdpStatisticApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  private async getBaseUrl(): Promise<string> {
    return this.discoveryApi.getBaseUrl('tdp-statistic');
  }

  private async get<T>(path: string): Promise<T> {
    const baseUrl = await this.getBaseUrl();
    const response = await this.fetchApi.fetch(`${baseUrl}${path}`);
    if (!response.ok) {
      throw new Error(
        `Request failed: ${response.status} ${response.statusText}`,
      );
    }
    return response.json();
  }

  async getSummary(): Promise<SummaryResponse> {
    return this.get('/summary');
  }

  async getTemplates(): Promise<TemplateStat[]> {
    return this.get('/templates');
  }

  async getSystems(): Promise<SystemStat[]> {
    return this.get('/systems');
  }

  async getOverTime(
    period: OverTimePeriod = 'month',
    templateRef?: string,
  ): Promise<OverTimeBucket[]> {
    const params = new URLSearchParams({ period });
    if (templateRef) params.set('templateRef', templateRef);
    return this.get(`/over-time?${params.toString()}`);
  }

  async getComponents(): Promise<ComponentRow[]> {
    return this.get('/components');
  }
}
